// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1958":"39e9e418","7272":"e35e2d92"}[chunkId] + ".chunk.css";
};